/**
 * Supported chains and their `chainId` for the SDK.
 * @enum
 */
export enum SupportedChainId {
    MAINNET = 1,
    GNOSIS_CHAIN = 100,
    ARBITRUM_ONE = 42161,
    SEPOLIA = 11155111,
}
